import { render } from "./App.vue?vue&type=template&id=7a429d82"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7a429d82&lang=css"

import exportComponent from "G:\\web\\webprog\\wk_hello_world\\wk_ball_01_10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__